import {gql} from '@apollo/client';
import React from 'react';

import {useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {ResultSchemaSubdependencyInputQuery} from './__generated/ResultSchemaSubdependencyInputQuery';
import BaseSchemaSubdependencyInput from './BaseSchemaSubdependencyInput';
import {ChildDependencyTypes} from './ChildDependencyTypes';

export const RESULT_SCHEMA_SUBDEPENDENCY_INPUT_QUERY = gql`
  query ResultSchemaSubdependencyInputQuery($id: StrictString!)
  @skipAudit
  @engComponent(name: BENCHLING_APPS) {
    resultSchema(id: $id) {
      ... on ResultSchemaNode {
        ...ResultSchemaGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('ResultSchema').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export default function ResultSchemaSubdependencyInput({
  subdependencies,
  onChange,
  dependencyValidation,
  updateDependencyConfigValidation,
  disabled,
  parentDependencySelectedId,
}: ChildDependencyTypes): JSX.Element | null {
  const result = useSkippableBenchlingQuery<ResultSchemaSubdependencyInputQuery>(
    RESULT_SCHEMA_SUBDEPENDENCY_INPUT_QUERY,
    {
      skip: parentDependencySelectedId == null,
      variables: {id: parentDependencySelectedId},
    }
  );
  return (
    <BaseSchemaSubdependencyInput<ResultSchemaSubdependencyInputQuery>
      subdependencies={subdependencies}
      onChange={onChange}
      dependencyValidation={dependencyValidation}
      updateDependencyConfigValidation={updateDependencyConfigValidation}
      disabled={disabled}
      result={result}
      getSchemaFromResult={(result) => result.data.resultSchema}
    />
  );
}
